import type { JsonValue } from '../../../../generated/nodeDataTypes'

/** Match the backend's committed_screenplay_fingerprint canonical JSON. */

function canonical(value: JsonValue): JsonValue {
  if (Array.isArray(value)) return value.map(canonical)
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0)
      .map(([key, item]) => [key, canonical(item)]))
  }
  if (typeof value === 'number' && !Number.isFinite(value)) throw new Error('Screenplay numbers must be finite')
  return value
}

export function screenplayCanonicalJSON(script: string, screenplayJSON: string): string {
  // Source scene wrappers are generated, but their toJSON() has the generic
  // Y.Map return type; round-trip into the JSON primitive tree before sorting.
  const screenplay: JsonValue = JSON.parse(screenplayJSON)
  if (!Array.isArray(screenplay)) throw new Error('Script Writer screenplay must be an array')
  return JSON.stringify(canonical({ out_script: script, out_screenplay: screenplay }))
}

export async function screenplayFingerprint(canonicalJSON: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(canonicalJSON))
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
}
